const hasKey = (obj, key) => {
  return typeof obj[key] !== 'undefined';
};

export { hasKey };
